import { BotElement } from '../types/model-types';
import { StatementElement } from '../types/serialized-types';
import { randomChoice } from '../utils';


@BotElement.register("statement")
class Statement extends BotElement {
    content: string[] = [];
    if: string | null = null;

    static fromJSON(obj: StatementElement): Statement {
        let s = new Statement(obj.type);
        s.if = obj.if || null;
        s.id = obj.id || null;
        s.content = obj.content;
        return s;
    }

    selectContent(): string {
        return randomChoice(this.content);
    }

}


export {
    Statement
}
